<template>
 <div style="margin-top: 25px;">
  <QS-h4-title title="个人租赁订单" />
  <QS-common-table
    :max-height="400"
    :data="tableData"
    :columns="columns"
    :pagination="false"
  />
 </div>
</template>
<script>
import config from './config'

export default {
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const { columns } = config.call(this)
    return {
      columns,
    }
  },
}
</script>
